import HeaderExample from "../../../../../../packages/design-system/src/Header/readme-helpers";
import * as React from 'react';
export default {
  HeaderExample,
  React
};